import { render, staticRenderFns } from "./CommentsSection.vue?vue&type=template&id=481d40e2&"
import script from "./CommentsSection.vue?vue&type=script&lang=ts&"
export * from "./CommentsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports